export class SubmitKey {
    constructor() {
        this.clear();
    }
    clear() {
        this.submitType = -1;
        this.blendShader = this.other = 0;
    }
}
